module.exports = __webpack_public_path__ + "img/abp_power_icon-1.c6630228.svg";